export const productBasicInfoLabel = JSON.stringify([
  [{ key: 'FeedbackTheme', label: '问题标题' }],
  [
    { key: 'CreatedName', label: '登记人' },
    { key: 'CreatedTime', label: '登记日期', isTime: true },
    { key: 'TypeEnum', label: '反馈类型' }
  ],
  [
    { key: 'SubSystemName', label: '子系统' },
    { key: 'ModuleName', label: '模块' },
    { key: 'EditionName', label: '产品版本' }
  ],
  [
    { key: 'CustomerFullName', label: '客户名称', canhidden: true },
    { key: 'EnterpriseCode', label: '企业代码', canhidden: true },
    { key: '', label: '' }
  ],
  [{ key: 'FeedbackDescribe', label: '描述', wrap: true, canedit: true }],
  [{ key: 'FileUpload', label: '附件', fujian: true, canedit: true }]
]);

// 当为产品建议时 采用此结构
export const productBasicInfoLabelForJY = JSON.stringify([
  [{ key: 'FeedbackTheme', label: '问题标题' }],
  [
    { key: 'CreatedName', label: '登记人' },
    { key: 'CreatedTime', label: '登记日期', isTime: true },
    { key: 'TypeEnum', label: '反馈类型' }
  ],
  [
    { key: 'SubSystemName', label: '子系统' },
    { key: 'ModuleName', label: '模块' },
    { key: 'CustomerFullName', label: '客户名称' }
  ],
  [{ key: 'EnterpriseCode', label: '企业代码', canhidden: true }],
  [{ key: 'FeedbackDescribe', label: '描述', wrap: true, canedit: true }],
  [{ key: 'FileUpload', label: '附件', fujian: true, canedit: true }]
]);

export const projectBasicInfoLabel = JSON.stringify([
  [{ key: 'FeedbackTheme', label: '问题标题' }],
  [
    { key: 'CreatedName', label: '登记人' },
    { key: 'CreatedTime', label: '登记日期', isTime: true },
    { key: 'TypeEnum', label: '反馈类型' }
  ],
  [
    { key: 'SubSystemName', label: '子系统' },
    { key: 'ModuleName', label: '模块' },
    { key: 'EditionName', label: '产品版本' }
  ],
  [
    { key: 'PmName', label: '二开PM', canhidden: true },
    { key: 'ProjectName', label: '项目名称', canhidden: true },
    { key: 'CustomerFullName', label: '客户名称', canhidden: true }
  ],
  [{ key: 'EnterpriseCode', label: '企业代码', canhidden: true }],
  [{ key: 'FeedbackDescribe', label: '描述', wrap: true, canedit: true }],
  [{ key: 'FileUpload', label: '附件', fujian: true, canedit: true }]
]);

/**
 * 产品进展
 */
export const productProcessLabel = [
  [
    { key: 'StatusEnum', label: '当前状态' },
    { key: 'HandleName', label: '当前处理人' },
    { key: 'OperateName', label: '默认经办人' }
  ],
  [
    { key: 'Workload', label: '产品工作量' },
    { key: 'PriorityLevel', label: '优先级' },
    { key: 'EstimatedTime', label: '预计发包时间', isTime: true }
  ],
  [{ key: 'JIRATypeEnum', label: 'JIRA问题类型' }],
  [{ key: 'Analysis', label: '产品分析', wrap: true }],
  [{ key: 'ProcessInfo', label: '处理过程', wrap: true }],
  [{ key: 'FileUpload', label: '附件', fujian: true, isjira: true }],
  [{ key: 'SLA', label: 'SLA信息', step: true }]
];

/**
 * 项目进展
 */
export const projectProcessLabel = [
  [
    { key: 'StatusEnum', label: '当前状态' },
    { key: 'HandleName', label: '当前处理人' },
    { key: 'TaskLimitTime', label: '预计完成时间', isTime: true }
  ],
  [
    { key: 'Workload', label: '项目工作量' },
    { key: 'PriorityLevel', label: '优先级' },
    { key: '', label: '' }
  ],
  [{ key: 'Analysis', label: '项目分析', wrap: true }],
  [{ key: 'SLA', label: 'SLA信息', step: true }]
];
